import styles from './checkbox.module.scss';
import checkMarkImage from '../../assets/icons/check.svg';

export interface FormCheckboxProps {
  label: string;
  name: string;
  formRegister: any;
  customStyle?: any;
  disabled?: boolean;
}
export function FormCheckbox(props: FormCheckboxProps) {
  const { label, name, formRegister, customStyle, disabled } = props;

  return (
    <div className={styles['container']}>
      <label
        className="flex items-center gap-2 text-gray-700 text-sm"
        htmlFor={name}
      >
        <input
          type="checkbox"
          id={name}
          name={name}
          {...formRegister}
          hidden
          className={styles['check-box']}
          style={customStyle}
          disabled={disabled}
        />
        <span className={`${styles['checkmark']} p-0.5 w-4 h-4`}>
          <img src={checkMarkImage} alt="check" />
        </span>
        {label}
      </label>
    </div>
  );
}
